import axios from 'axios';
import $common from '../util/common.js'
import router from '@/router'
import Vue from 'vue';
let V = new Vue();

const httpDowload = axios.create({
	baseUrl: '/api',
	timeout: 1000*300 , // 五分钟
	withCredentials: false, // 跨域请求是否提供凭据信息(当前请求为跨域类型时是否在请求中协带cookie)
	headers: {
	    'Content-Type': 'application/json; charset=utf-8',
		'ATOKEN': $common.getItem('ATOKEN')
	}
});

// 存储请求地址
var Action = (function(){
  let actions = {};
  let timeout = 500; // 500毫秒内不能重复访问
  return {
    set(url){
      actions[url] = true;
    },
    get(url){
      return actions[url];
    },
    remove(url){
      setTimeout(() => {
        actions[url] = false;
      }, timeout);
    }
  }
})();

// 请求拦截
httpDowload.interceptors.request.use(config => {

	// console.log($store.state.ATOKEN)
	config.headers['ATOKEN'] = $common.getItem('ATOKEN');
	let _url = config.url;
	// if(Action.get(_url)){
	// 	console.log("拦截了一个重复的请求", _url);
	// 	return Promise.reject({msg:'请求过于频繁,请稍后重试!'});
	// }else{
		Action.set(_url);
	// }
	let _time = new Date().getTime();
	if(_url.indexOf('?') >=  0){
		_url += '&t='+ _time;
	}else{
		_url += '?t='+ _time;
	}
	config.url = _url;
	return config;
}, error => {
	console.info("开始-1");

	return Promise.reject(error);
});

// 响应拦截
httpDowload.interceptors.response.use(response =>{
	console.info("开始");
	let _config = response.config;
	let _url = _config.url;
	Action.remove(_url);
	if(response.status == 200){
		// 响应共通处理
		if(response.data.status == "-21"){
			// ATOKEN 无效
			router.push({ path: 'login' }, () => {})
		}else if(response.data.status == "-100"){
			console.info("开始2");

			V.$notify.error({
			  title: 'ERROR',
			  message: '数据请求异常，请稍后再试！'
			});
		}else if(response.data.status == "200"){
			
		}else{

		}
	}else{

		V.$notify.error({
		  title: 'ERROR',
		  message: '数据请求异常，请稍后再试！'
		});
	}
	return response;
},error => {

	let _config = error.response.config;
	let _url = _config.url;
	Action.remove(_url);
	return Promise.reject(error)
});

export default httpDowload;